import React, { Component } from "react"
import { Popover, PopoverBody, Label, Button } from "reactstrap"
import withApolloClient from '../withApolloClient'
import "./BranchSelectionPopover.css"

class BranchSelectionPopover extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedBranches: this.props.selectedBranches || [],
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedBranches !== this.props.selectedBranches && this.props.open) {
            this.setState({ selectedBranches: this.props.selectedBranches || [] })
        }
    }

    updateBranchSelection = (branchId) => {
        const selectedBranches = this.state.selectedBranches.includes(branchId)
            ? this.state.selectedBranches.filter((branch) => branch !== branchId)
            : [...this.state.selectedBranches, branchId]
        this.setState({ selectedBranches })
    }

    applyFilter = () => {
        this.props.updateSelectedBranches(this.state.selectedBranches)
        this.props.handleClose()
    }

    bulkUpdateBranches = () => {
        const allBranchIds = (this.props.userBranches || []).map((item) => item.node.id)
        const allSelected = allBranchIds.length > 0 && allBranchIds.every((id) => this.state.selectedBranches.includes(id))
        this.setState({ selectedBranches: allSelected ? [] : allBranchIds })
    }

    render() {
        const { open, handleClose, target, userBranches = [] } = this.props
        const selectedCount = userBranches.filter((item) => this.state.selectedBranches.includes(item.node.id)).length
        const allSelected = userBranches.length > 0 && selectedCount === userBranches.length

        return (
            <Popover
                placement="bottom-end"
                trigger="legacy"
                target={target}
                isOpen={open}
                toggle={handleClose}
                className="branch-selection-popover"
            >
                <PopoverBody className="branch-selection-popover-body">
                    <div className="branch-selection-header">
                        <div>
                            <div className="branch-selection-title">Branches</div>
                            <div className="branch-selection-count">{selectedCount} selected</div>
                        </div>
                        <button type="button" className="branch-selection-close" onClick={handleClose} aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="branch-selection-toolbar">
                        <button type="button" className="branch-selection-link" onClick={this.bulkUpdateBranches}>
                            {allSelected ? "Unselect All" : "Select All"}
                        </button>
                        <button type="button" className="branch-selection-link branch-selection-link-muted" onClick={() => this.setState({ selectedBranches: [] })}>
                            Clear
                        </button>
                    </div>

                    <div className="branch-selection-list">
                        {userBranches.map((branch) => (
                            <Label key={branch.node.id} className="branch-selection-item">
                                <input
                                    className="branch-selection-checkbox"
                                    type="checkbox"
                                    checked={this.state.selectedBranches.includes(branch.node.id)}
                                    onChange={() => this.updateBranchSelection(branch.node.id)}
                                />
                                <span className="branch-selection-item-name">{branch.node.name}</span>
                            </Label>
                        ))}
                    </div>
                    <div className="branch-selection-actions">
                        <Button color="light" size="sm" onClick={handleClose}>
                        Cancel
                        </Button>
                        <Button color="primary" size="sm" onClick={this.applyFilter}>
                        Apply
                        </Button>
                    </div>
                </PopoverBody>
            </Popover>
        )
    }
}

export default withApolloClient(BranchSelectionPopover)
